import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/seo";
import Modules from "../components/modules";
import clsx from "clsx";
// import Scrollspy from "react-scrollspy";
// import Aside from "../components/Aside";
// import MaskFlash from "../components/MaskFlash";
// import { _localizeField } from "../core/utils";

export const query = graphql`
  query PageBySlug($slug: String!) {
    sanityPageModulaire(slug: { current: { eq: $slug } }) {
      home
      slug {
        current
      }
      seo {
        ...seo
      }
      modules {
        ... on SanityTiroirUI {
          _type
          title
          caption
          linkLabel
          link: _rawLink(resolveReferences: { maxDepth: 10 })
        }
        ... on SanityImageUI {
          _type
          title
          caption
          image: _rawImage(resolveReferences: { maxDepth: 10 })
          linkObject: link {
            label
            rel
            link: _rawLink(resolveReferences: { maxDepth: 10 })
          }
        }
        ... on SanityMockupUI {
          _type
          title
          caption
          color
          image: _rawImage(resolveReferences: { maxDepth: 10 })
          # link {
          #   ...link
          # }
        }
        ... on SanityPlancheContactUI {
          _type
          _type
          template
          caption
          linkObject: link {
            label
            rel
            link: _rawLink(resolveReferences: { maxDepth: 10 })
          }
          images: _rawImages(resolveReferences: { maxDepth: 10 })
        }
        ... on SanityTexteUI {
          _type
          title
          texte: _rawTexte(resolveReferences: { maxDepth: 10 })
        }
        ... on SanityStoryTexteUI {
          _type
          title
          credits {
            texte
            column
          }
          chapo
          texte: _rawTexte(resolveReferences: { maxDepth: 10 })
        }
        ... on SanityStoryItwUI {
          _type
          title
          credits {
            texte
            column
          }
          chapo

          interviewer
          guest
          questionsReponses {
            question
            reponse: _rawReponse
          }
        }
        ... on SanityProductUI {
          _type
          showImage
          color
          product: _rawProduct(resolveReferences: { maxDepth: 10 })
        }
      }
    }
  }
`;

const PageModulaire = ({ data }) => {
  const { home, slug, seo, modules } = data.sanityPageModulaire;
  // console.log(title);
  // const homeClass = home ? "home" : "";
  // const shopClass = slug.current === "shop" ? "catalog" : "";
  return (
    <>
      {seo && (
        <Seo
          pageTitle={seo.metaTitle}
          pageDescription={seo.metaDescription}
          pageImage={seo.image.asset.url}
          // template={`template-modulaire ${homeClass} ${shopClass}`}
          template={clsx(
            "template-modulaire",
            home ? "home" : "",
            slug.current === "shop" ? "shop" : ""
          )}
          page={!home}
        />
      )}

      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}

      {modules && <Modules input={modules} />}
    </>
  );
};

export default PageModulaire;
